// extracted by mini-css-extract-plugin
export default {"page":"UF","top_block":"VF","heading":"WF","inner_text":"XF","starter_text":"YF","starter_cta":"ZF","summary_block":"aG","cartsummary_wrap":"bG","price":"cG","pricing_wrap":"eG","summary_block_mob":"fG","summary":"gG","pricing_heading":"hG","products_summary":"iG","summary_line":"jG","summary_price":"kG","summary_title":"lG"};
    if(module.hot) {
      // 1726593106256
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  